<template>
  <div class="email-page-wrapper">
    <div>
      <div @click="handleBackClick" class="back-to-profile-text">
        <div class="container padding-a-25px">
          <a-icon class="margin-t-3px" type="arrow-left" />
          <span class="margin-l-1">Back to profile</span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="email-page-header-text">
        <h2>Email {{ coach.coachname }}</h2>
      </div>
      <div class="d-flex-column message-input-wrapper">
        <p class="message-text">
          Message:
        </p>
        <QuillEditor class="message-input-box" :rows="5" ref="editor" />
      </div>
      <div
        v-if="this.onlyPlayer()"
        class="padding-top-1 d-flex-spc-btwn profile-link-wrapper"
      >
        <div>
          <a-icon type="link" />
          <span class="link-text" @click="handleProfileLinkAddition"
            >Insert Profile Link</span
          >
        </div>

        <div>
          <a-tooltip>
            <template slot="title"
              >Click the link to add your profile link in the message</template
            >
            <BaseIcon class="" type="info-circle" />
          </a-tooltip>
        </div>
      </div>
      <div class="padding-top-1">
        <a-button
          @click="handleButtonClick"
          class="button-primary"
          type="primary"
          :loading="mailToCoachLoading"
        >
          Submit</a-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { additionalCoachText, subjectText } from "./coachText";
import { Coach } from "@/models";
import QuillEditor from "@/components/quill";

const COACH_STORE_KEY = "coachStore";
const CHAT_STORE_KEY = "chatStore";

export default {
  mounted() {
    this.$store.dispatch(`${CHAT_STORE_KEY}/getSenderProfile`);
    this.$store.dispatch(`${COACH_STORE_KEY}/getCoach`, {
      id: sessionStorage["coach-id"]
    });
  },
  computed: {
    ...mapGetters({
      userProfile: `${CHAT_STORE_KEY}/senderProfile`,
      mailToCoachLoading: `${COACH_STORE_KEY}/coachMailLoading`,
      coach: `${COACH_STORE_KEY}/coach`
    })
  },
  components: {
    QuillEditor
  },
  data() {
    return {
      mailText: "",
      subject: "",
      additionalCoachText,
      subjectText,
      slugMapper: {
        collegeCoach: "collegeCoach",
        athlete: "athleteProfile",
        clubCoach: "clubCoach"
      }
    };
  },
  methods: {
    handleProfileLinkAddition() {
      this.mailText =
        this.mailText +
        `
My Profile Link: ${window.location.origin}/athlete/${localStorage["profile-id"]}/fromlink`;
      const editor = document.getElementById("editor");
      if (editor && editor.children[0]) {
        let profileLink = document.createElement("p");
        profileLink.innerText = `My Profile Link: ${window.location.origin}/athlete/${localStorage["profile-id"]}/fromlink`;
        document.getElementById("editor").children[0].appendChild(profileLink);
      }
    },

    async handleButtonClick() {
      this.mailText = this.$refs.editor.getQuillBody();

      if (Coach.userType() === "athlete") {
        this.subject = this.subjectText(
          Coach.userType(),
          this.userProfile.athletename
        );
      } else if (Coach.userType() === "clubCoach") {
        this.subject = this.subjectText(
          Coach.userType(),
          this.userProfile.coachname,
          this.userProfile.clubId.clubName
        );
      } else
        this.subject = this.subjectText(
          Coach.userType(),
          this.userProfile.coachname,
          this.userProfile.CollegeId.collegeName
        );
      this.mailText = this.mailText;
      await this.$store.dispatch(`${COACH_STORE_KEY}/contactCoachByMail`, {
        mailedUserId: sessionStorage["coach-id"],
        message: this.mailText + additionalCoachText,
        profileId: this.$route.params.profileId,
        subject: this.subject,
        slug: this.slugMapper[Coach.userType()]
      });
      this.$refs.editor.clearData();
      this.mailText = "";
    },
    handleBackClick() {
      this.$router.back();
    }
  }
};
</script>

<style lang="scss">
.email-page-wrapper {
  padding-bottom: 1rem;
  background: #f0f0f0;
  .back-to-profile-container {
    padding: 1rem 23rem;
  }
  .email-page-header-text {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .message-text {
    font-weight: 400;
    font-size: 14px;
  }
  .profile-link-wrapper {
    width: 9rem;
  }
  .message-input-box {
    height: 30rem !important;
    .ql-editor {
      background: white;
    }
  }
}
</style>
